import { useState } from "react"
import { CreateMessageDialog } from "../../../modules/merchant/admin/messages/components/CreateMessageDialog"
import { useOrderDialogUrlState } from "../../components/createOrder/hooks/useOrderDialogUrlState"
import { createTopBarNewMenuItem } from "../../components/topBarNewButtonMenu/topBarNewMenuItems"
import { TopBarNewButton } from "../../components/topBarNewButtonMenu/TopBarNewButton"
import { CreateOrderType } from "../../components/createOrder/helpers"
import {
    TopBarNewButtonMenu,
    UserActionsMenuItemConfig,
} from "../../components/topBarNewButtonMenu/TopBarNewButtonMenu"

type CrateOrderButtonProps = {
    isMerchantUser?: boolean
}

export function MainTopBarNewButton({ isMerchantUser }: CrateOrderButtonProps) {
    const { openDialog } = useOrderDialogUrlState()

    const [isCreateMessageOpen, setIsCreateMessageOpen] = useState(false)

    const handleCreateOrder = (activeOrderTab?: CreateOrderType) => {
        openDialog({ activeOrderTab })
    }

    const handleOpenCreateMessage = () => {
        setIsCreateMessageOpen(true)
    }

    const handleCloseCreateMessage = () => {
        setIsCreateMessageOpen(false)
    }

    if (isMerchantUser) {
        const items: UserActionsMenuItemConfig[] = [
            createTopBarNewMenuItem("push-message", handleOpenCreateMessage),
            createTopBarNewMenuItem("meeting-service", () => handleCreateOrder(CreateOrderType.MEETING_SERVICE)),
        ]

        return (
            <>
                <TopBarNewButtonMenu items={items} />
                {isCreateMessageOpen && (
                    <CreateMessageDialog open={isCreateMessageOpen} onClose={handleCloseCreateMessage} />
                )}
            </>
        )
    }

    return <TopBarNewButton onClick={() => handleCreateOrder()} />
}
